{
  "page_count": "z {n, plural, one{# strany} other{# strán}}"
}
